import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({

    androidContainer:{
        display:'flex',
        paddingTop: '24px',

        '& .android-Box1':{
            paddingRight: '24px',
            paddingLeft: '12px',
        },

        '& .android-Box2':{
            paddingRight: '12px',
            paddingLeft: '24px',
            '& .screen-box':{
                display:'flex',
                // rowGap: '16px',
                flexWrap: 'wrap',
                columnGap: '24px',
            },
        },
    },
    formInput : {
        marginTop : '0px !important'
    },
    boxlabel:{
        fontSize:'13px',
        userSelect: 'none',
        lineHeight : "32px",
        fontWeight: 400
    }
}));

export default useStyles;